export default "__VITE_ASSET__C2IY0Ur9__"